import { useUpdateAppointmentStatus } from "@/queries/use-change-appointment-status";
import { getXtenantId } from "@/utils/utils";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback, useState } from "react";
import {
  APPOINTMENT_CHANGE_STATUS,
  APPOINTMENT_STATUS_CHANGE_INVALIDATE_QUERY_KEYS,
  APPOINTMENT_STATUS_CHANGE_MESSAGE,
} from "../appointment-status-change-constant";
import { AppointmentStatusChangeModalProps } from "../appointment-status-change-types";

interface UseAppointmentStatusChangeResult {
  reason: string;
  setReason: (reason: string) => void;
  handleClose: () => void;
  handleConfirm: () => Promise<void>;
}

/**
 *
 * @author [Rajkumar Rathod]
 */
export const useAppointmentStatusChange = ({
  disclosureHost,
  appointmentId,
  status,
  onSuccess,
}: AppointmentStatusChangeModalProps): UseAppointmentStatusChangeResult => {
  const client = useQueryClient();
  const { mutateAsync: updateStatus } = useUpdateAppointmentStatus();
  const [reason, setReason] = useState<string>("");

  const handleClose = useCallback(() => {
    setReason("");
    disclosureHost.close();
  }, [disclosureHost]);

  console.log("val here check ", status);
  const handleConfirm = useCallback(async () => {
    if (
      (status === APPOINTMENT_CHANGE_STATUS.CANCELLED ||
        status === APPOINTMENT_CHANGE_STATUS.NO_SHOW) &&
      !reason.trim()
    ) {
      // DeleteModal reads the error snackbar text from this axios-like shape.
      return Promise.reject({
        response: {
          data: { message: APPOINTMENT_STATUS_CHANGE_MESSAGE.REASON_REQUIRED },
        },
      });
    }

    const res = await updateStatus({
      reason,
      appointmentId: appointmentId ?? "",
      status,
      xTENANTID: getXtenantId(),
    });

    APPOINTMENT_STATUS_CHANGE_INVALIDATE_QUERY_KEYS.forEach((queryKey) =>
      client.invalidateQueries({ queryKey })
    );
    const message = res.data?.message;
    onSuccess?.(typeof message === "string" ? message : "");
    handleClose();
  }, [
    appointmentId,
    client,
    handleClose,
    onSuccess,
    reason,
    status,
    updateStatus,
  ]);

  return { reason, setReason, handleClose, handleConfirm };
};
